import React from 'react';
import { Button, ButtonGroup } from '@superops/ui-design-system';
import { BackgroundIcon } from '@nile/components';
import envConfig from '@nile/home/src/Config/env';
import { FormattedMessage } from 'react-intl';
import { SVGIcon } from '@superops/super-icons';

export const ActionCell = (props) => {
  const { cell, intl } = props;
  const { original } = cell?.row;
  const { action, meta = '' } = cell.column;
  const { staticIcon = false, size = 'medium' } = meta;
  return (
    <div className={`${!staticIcon && 'action-button'}`}>
      <ButtonGroup>
        <Button
          id="alertManagementDanger"
          onClick={() => action({ ...original, meta })}
          size={size}
        >
          <div className="fx actr">
            {meta?.svgIcon ? (
              <div className="mr-10 fx center">
                <SVGIcon name={meta?.svgIcon} color={meta?.color} />
              </div>
            ) : (
              <div className="mr-10 fx center">
                <SVGIcon name={meta.icon} />
              </div>
            )}
            <FormattedMessage id={meta?.buttonName} />
          </div>
        </Button>
      </ButtonGroup>
    </div>
  );
};
